<div class="content">
  <div class="filters-row">
    <app-input [formControl]="searchValueControl" [placeholder]="'labels.search'|translate">
      <i class="pi pi-search"></i>
    </app-input>
<!--
    <app-filter-control
      *ngIf="filtersStatusConfig()"
      [selectedControlValue]="filtersStatusConfigCurrentValue()"
      (onSubmitFilters$)="onChangeStatusFilters($event)"
      [data]="filtersStatusConfig()"
      [optionsSelectedCount]="
        filtersStatusConfigCurrentValue()?.selectedControlValue ? 1 : 0
      "
      class="header__filters__vehicle"
    ></app-filter-control>

    <app-filter-control
      *ngIf="filtersCompanyConfig()"
      [selectedControlValue]="filtersCompanyConfigCurrentValue()"
      (onSubmitFilters$)="onChangeCompanyFilters($event)"
      [data]="filtersCompanyConfig()"
      [optionsSelectedCount]="
        filtersCompanyConfigCurrentValue()?.selectedControlValue ? 1 : 0
      "
      class="header__filters__vehicle"
    ></app-filter-control> -->

    <button pButton (click)="addVehicle()" class="header__filters__submit">
      <i class="pi pi-plus" pButtonIcon></i>
      <span pButtonLabel>
        {{ "addVehicle" | translate }}
      </span>
    </button>

    <span class="refresh-info">
      <i class="pi pi-spin pi-spinner"></i>
      {{ 'autoRefreshData' | translate}}
    </span>
  </div>

  <div #containerList class="content__list-wrapper">
    <app-tachograph-files-list
      (onChangeDownloadMode$)="onChangeDownloadMode($event)"
      (onChangeCompanyCard$)="onChangeCompanyCard($event)"
      (openFiles$)="openFiles$.emit($event)"
      [isLoading]="isLoadingInit()"
      [searchValueControl]="searchValueControl.value"
      [isCheckedAll]="isCheckedAll"
      [list]="filesFasade.vehicleList()"
      [selectedItems]="selectedItems()"
      (forceFile$)="forceFile($event)"
      (onToggleSelectedAll$)="onChangeValueCheckedAll($event)"
      (onSelectItem$)="onCheckedItem($event)"
      [companyCards]="cards()"
    ></app-tachograph-files-list>
  </div>

  <div class="content__footer">
    <div class="left">
      <!-- selectedItems().length -->
      <ng-container *ngIf="false">
        <span class="count-checked-row"
          >{{ selectedItems().length }}
          {{ "labels.selected" | translate }}</span
        >

        <!-- <button pButton (click)="deleteVehicles()" [loading]="isDeletingItems()" severity="secondary" class="button-submit-checked-row">
          <i class="pi pi-trash" pButtonIcon></i>
          <span pButtonLabel>
            {{ "Usuń" | translate }}
          </span>
        </button> -->
        <button (click)="onGetSelectedItems()" pButton severity="secondary" class="button-submit-checked-row">
          <i class="pi pi-cloud-download" pButtonIcon></i>
          <span pButtonLabel>
            {{ "getRemote" | translate }}
          </span>
        </button>
      </ng-container>
    </div>
  </div>
</div>

<p-dialog header="Dodaj pojazd" [modal]="true" [(visible)]="visibleForm" [style]="{ width: '720px' }">
  <div class="add-vehicle-form">
    <p-treeselect
      [(ngModel)]="selectedVehiclesForm"
      [options]="vehiclesTreeList()"
      [filter]="true"
      [placeholder]="'selectVehicles' | translate"
      scrollHeight="200px"
      selectionMode="checkbox"
    />
    <span>{{ 'listOfAddedVehicles' | translate}}:</span>
    <div class="add-vehicle-form__list-of-addeed">
      <p-chip *ngFor="let item of filesFasade.vehicleList()" [label]="item.Vehicle.Nm" />
    </div>

    <div class="flex justify-end gap-2 add-vehicle-form__actions">
      <p-button [label]="'primeng.cancel' | translate" severity="secondary" (click)="visibleForm = false" />
      <p-button [label]="'labels.add' | translate" (click)="onAddVehicles()" />
    </div>
  </div>
</p-dialog>
